import {
  InspectorControlsAppearance,
  InspectorControlsGeneral,
  InspectorTabs,
} from '@components/inspector-tabs';
import Visibility from '@components/visibility';
import ClassDropdown, { getBlockClassNames } from '@components/class-dropdown';
import Label from '@components/block-label';
import {
  FocusableIcon,
  FocusableIconSwitcher,
} from '@components/focusable-block-icon';
import { title } from './block.json';
import rowIcon from './icon';
import { DEFAULT_CSS_CLASS, BERG_STORE } from '@constants';
import classnames from 'classnames';

import './editor.scss';

const {
  i18n: { __ },
  blockEditor: { useBlockProps, useInnerBlocksProps },
  components: { PanelBody, SelectControl },
  data: { select },
  element: { useEffect },
} = wp;

const Edit = (props) => {
  const { attributes, setAttributes, name } = props;
  const {
    blockVisibility,
    blockClassNames,
    childBlocksDirectionClass,
    childBlocksHorizontalAlignClass,
    displayTypeClass,
    label,
    enableFocusableIcon,
  } = attributes;

  const childBlocksHorizontalAlignClassOptions = select(
    BERG_STORE,
  ).getBlockAttributeOptions(name, 'childBlocksHorizontalAlignClass');

  const childBlocksDirectionClassOptions = select(
    BERG_STORE,
  ).getBlockAttributeOptions(name, 'childBlocksDirectionClass');

  const ALLOWED_BLOCKS = ['b3rg/column'];

  const defaultBlockCssClass = DEFAULT_CSS_CLASS.ROW;
  const classNames = getBlockClassNames(blockClassNames);

  // set the default class for displayTypeClass
  useEffect(() => {
    setAttributes({ displayTypeClass: 'row' });
  }, [setAttributes]);

  const blockProps = useBlockProps({
    className: classnames({
      [`${defaultBlockCssClass}`]: true,
      [`${displayTypeClass}`]: displayTypeClass,
      [`${childBlocksHorizontalAlignClass}`]: childBlocksHorizontalAlignClass,
      [`${childBlocksDirectionClass}`]: childBlocksDirectionClass,
      [`${classNames}`]: classNames,
      disable: !blockVisibility,
    }),
  });

  const { children, ...innerBlocksProps } = useInnerBlocksProps(blockProps, {
    allowedBlocks: ALLOWED_BLOCKS,
  });

  return (
    <>
      <InspectorTabs>
        <InspectorControlsGeneral>
          <Label {...{ label, setAttributes }} />
          <Visibility {...{ blockVisibility, setAttributes }} />

          <PanelBody title={__('Row Flex Classes', 'b3rg')} initialOpen={false}>
            <SelectControl
              label={__('Justify Content', 'b3rg')}
              value={childBlocksHorizontalAlignClass}
              options={childBlocksHorizontalAlignClassOptions}
              onChange={(value) => {
                setAttributes({ childBlocksHorizontalAlignClass: value });
              }}
            />

            <SelectControl
              label={__('Direction', 'b3rg')}
              value={childBlocksDirectionClass}
              options={childBlocksDirectionClassOptions}
              onChange={(value) => {
                setAttributes({ childBlocksDirectionClass: value });
              }}
            />
          </PanelBody>
        </InspectorControlsGeneral>
        <InspectorControlsAppearance>
          <ClassDropdown
            {...{
              blockClassNames,
              setAttributes,
              initialOpen: true,
              blockClassPrefix: DEFAULT_CSS_CLASS.ROW,
            }}
          />
          <FocusableIconSwitcher
            {...{
              enableFocusableIcon,
              setAttributes,
            }}
          />
        </InspectorControlsAppearance>
      </InspectorTabs>
      <div {...innerBlocksProps}>
        {enableFocusableIcon && <FocusableIcon {...{ title, icon: rowIcon }} />}
        {children}
      </div>
    </>
  );
};

export default Edit;
